import { routes } from '../../const/';
import { handleRedirect } from '@/utils/redirectHandler';

export default function guest({ to, next, store }) {
  store.dispatch('register/checkCookies');
  if (store.getters.isAuth) {
    const step = store.getters['register/registrationStep'];
    if (step) {
      if (!routes.some(r => r == step)) {
        store.dispatch('appLogout');

        return next({
          name: 'REDIRECT',
          query: { redirect: handleRedirect(to.query.redirect) },
        });
      } else {
        return next({
          name: step,
        });
      }
    } else {
      store.dispatch('appLogout');
      return next({
        name: 'REDIRECT',
        query: { redirect: handleRedirect(to.query.redirect) },
      });
    }
  }
  return next();
}
